<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-10-08 16:42:43
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-08 16:53:07
 * @FilePath: \crm-product\found\views\mdm\views\terminal_info\address\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';
import { ProcessLog } from '@/found/modules';

export default {
  name: 'Address',
  extends: TablePage,
  data() {
    return {
      params: {},
    };
  },
  props: {
    propsObj: Object,
  },
  components: {
    ProcessLog,
  },
  async created() {
    this.params = { terminalCode: this.propsObj.terminalCode };
    await this.getConfigList('address_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: { processNo: row.processNo },
        };

        this.modalConfig.title = '流程日志';
        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
  },
};
</script>
